const TEXT_MIME = 'text/plain';
const PDF_MIME = 'application/pdf';

export type U3204AttachmentFormatKind = 'text' | 'pdf' | 'image';

/**
 * Déduit les catégories de formats affichables pour le tooltip du bouton pièce jointe.
 */
export function u3204DescribeSupportedAttachmentFormatKinds(
  allowedMimeTypes: readonly string[],
): U3204AttachmentFormatKind[] {
  const kinds: U3204AttachmentFormatKind[] = [];
  if (allowedMimeTypes.includes(TEXT_MIME)) {
    kinds.push('text');
  }
  if (allowedMimeTypes.includes(PDF_MIME)) {
    kinds.push('pdf');
  }
  if (allowedMimeTypes.some((mime) => mime.startsWith('image/'))) {
    kinds.push('image');
  }
  return kinds;
}
